import { InjectionToken, Inject, Injectable, NgModule, Optional, SkipSelf } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { Router, ActivatedRoute, RouterModule } from '@angular/router';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/router';
import * as ɵngcc2 from '@angular/platform-browser';
const META_CONFIG_TOKEN = new InjectionToken('meta config');
/** @type {?} */
const META_GUARD_IDENTIFIER = 'MetaGuard';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
const isDefined = (val) => typeof val !== 'undefined';
class MetaService {
    /**
     * @param {?} router
     * @param {?} meta
     * @param {?} titleService
     * @param {?} activatedRoute
     * @param {?} metaConfig
     */
    constructor(router, meta, titleService, activatedRoute, metaConfig) {
        this.router = router;
        this.meta = meta;
        this.titleService = titleService;
        this.activatedRoute = activatedRoute;
        this.metaConfig = metaConfig;
        this._warnMissingGuard();
    }
    /**
     * @param {?=} title
     * @param {?=} titleSuffix
     * @return {?}
     */
    setTitle(title, titleSuffix) {
        /** @type {?} */
        let titleContent = isDefined(title) ? title : (this.metaConfig.defaults['title'] || '');
        if (this.metaConfig.useTitleSuffix) {
            titleContent += isDefined(titleSuffix) ? titleSuffix : (this.metaConfig.defaults['titleSuffix'] || '');
        }
        this._updateMetaTag('title', titleContent);
        this._updateMetaTag('og:title', titleContent);
        this.titleService.setTitle(titleContent);
        return this;
    }
    /**
     * @param {?} tag
     * @param {?} value
     * @return {?}
     */
    setTag(tag, value) {
        if (tag === 'title' || tag === 'titleSuffix') {
            throw new Error(`Attempt to set ${tag} through 'setTag': 'title' and 'titleSuffix' are reserved tag names.
      Please use 'MetaService.setTitle' instead`);
        }
        /** @type {?} */
        let content = isDefined(value) ? value : (this.metaConfig.defaults[tag] || '');
        this._updateMetaTag(tag, content);
        if (tag === 'description') {
            this._updateMetaTag('og:description', content);
        }
        return this;
    }
    /**
     * @param {?} tag
     * @param {?} value
     * @return {?}
     */
    _updateMetaTag(tag, value) {
        /** @type {?} */
        let prop = 'name';
        if (tag.startsWith(`og:`)) {
            prop = 'property';
        }
        this.meta.updateTag({
            [prop]: tag,
            content: value
        });
    }
    /**
     * @return {?}
     */
    _warnMissingGuard() {
        if (isDefined(this.metaConfig.warnMissingGuard) && !this.metaConfig.warnMissingGuard) {
            return;
        }
        /** @type {?} */
        const hasDefaultMeta = !!Object.keys(this.metaConfig.defaults).length;
        /** @type {?} */
        const hasMetaGuardInArr = (it) => (it && it.IDENTIFIER === META_GUARD_IDENTIFIER);
        /** @type {?} */
        let hasShownWarnings = false;
        this.router.config.forEach((route) => {
            /** @type {?} */
            const hasRouteMeta = route.data && route.data["meta"];
            /** @type {?} */
            const showWarning = !isDefined(route.redirectTo)
                && (hasDefaultMeta || hasRouteMeta)
                && !(route.canActivate || []).some(hasMetaGuardInArr);
            if (showWarning) {
                console.warn(`Route with path "${route.path}" has ${hasRouteMeta ? '' : 'default '}meta tags, but does not use MetaGuard. \
Please add MetaGuard to the canActivate array in your route configuration`);
                hasShownWarnings = true;
            }
        });
        if (hasShownWarnings) {
            console.warn(`To disable these warnings, set metaConfig.warnMissingGuard: false \
in your ng2-meta MetaConfig passed to MetaModule.forRoot()`);
        }
    }
}
MetaService.ɵfac = function MetaService_Factory(t) { return new (t || MetaService)(ɵngcc0.ɵɵinject(ɵngcc1.Router), ɵngcc0.ɵɵinject(ɵngcc2.Meta), ɵngcc0.ɵɵinject(ɵngcc2.Title), ɵngcc0.ɵɵinject(ɵngcc1.ActivatedRoute), ɵngcc0.ɵɵinject(META_CONFIG_TOKEN)); };
MetaService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: MetaService, factory: MetaService.ɵfac });
/** @nocollapse */
MetaService.ctorParameters = () => [
    { type: Router },
    { type: Meta },
    { type: Title },
    { type: ActivatedRoute },
    { type: undefined, decorators: [{ type: Inject, args: [META_CONFIG_TOKEN,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MetaService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.Router }, { type: ɵngcc2.Meta }, { type: ɵngcc2.Title }, { type: ɵngcc1.ActivatedRoute }, { type: undefined, decorators: [{
                type: Inject,
                args: [META_CONFIG_TOKEN]
            }] }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
const DEFAULT_META_CONFIG = {
    useTitleSuffix: false,
    warnMissingGuard: true,
    defaults: {}
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class MetaGuard {
    /**
     * @param {?} router
     * @param {?} metaService
     * @param {?} metaConfig
     */
    constructor(router, metaService, metaConfig) {
        this.router = router;
        this.metaService = metaService;
        this.metaConfig = metaConfig;
    }
    /**
     * @param {?} route
     * @param {?} state
     * @return {?}
     */
    canActivate(route, state) {
        this._processRouteMetaTags(route.data && route.data["meta"]);
        return true;
    }
    /**
     * @param {?=} meta
     * @return {?}
     */
    _processRouteMetaTags(meta = {}) {
        if (meta.disableUpdate) {
            return;
        }
        this.metaService.setTitle(meta.title, meta.titleSuffix);
        Object.keys(meta).forEach(key => {
            if (key === 'title' || key === 'titleSuffix') {
                return;
            }
            this.metaService.setTag(key, meta[key]);
        });
        Object.keys(this.metaConfig.defaults).forEach(key => {
            if (key in meta || key === 'title' || key === 'titleSuffix') {
                return;
            }
            this.metaService.setTag(key, this.metaConfig.defaults[key]);
        });
    }
}
MetaGuard.ɵfac = function MetaGuard_Factory(t) { return new (t || MetaGuard)(ɵngcc0.ɵɵinject(ɵngcc1.Router), ɵngcc0.ɵɵinject(MetaService), ɵngcc0.ɵɵinject(META_CONFIG_TOKEN)); };
MetaGuard.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: MetaGuard, factory: MetaGuard.ɵfac });
MetaGuard.IDENTIFIER = META_GUARD_IDENTIFIER;
/** @nocollapse */
MetaGuard.ctorParameters = () => [
    { type: Router },
    { type: MetaService },
    { type: undefined, decorators: [{ type: Inject, args: [META_CONFIG_TOKEN,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MetaGuard, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.Router }, { type: MetaService }, { type: undefined, decorators: [{
                type: Inject,
                args: [META_CONFIG_TOKEN]
            }] }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class MetaModule {
    /**
     * @param {?} parentModule
     */
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('MetaModule is already loaded. Import it in the AppModule only');
        }
    }
    /**
     * @param {?=} metaConfig
     * @return {?}
     */
    static forRoot(metaConfig = DEFAULT_META_CONFIG) {
        return {
            ngModule: MetaModule,
            providers: [
                { provide: META_CONFIG_TOKEN, useValue: metaConfig },
                MetaGuard,
                MetaService
            ]
        };
    }
}
MetaModule.ɵfac = function MetaModule_Factory(t) { return new (t || MetaModule)(ɵngcc0.ɵɵinject(MetaModule, 12)); };
MetaModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: MetaModule });
MetaModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            RouterModule
        ]] });
/** @nocollapse */
MetaModule.ctorParameters = () => [
    { type: MetaModule, decorators: [{ type: Optional }, { type: SkipSelf }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MetaModule, [{
        type: NgModule,
        args: [{
                imports: [
                    RouterModule
                ]
            }]
    }], function () { return [{ type: MetaModule, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }] }]; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MetaModule, { imports: function () { return [RouterModule]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

export { MetaService, MetaModule, MetaGuard, DEFAULT_META_CONFIG as ɵa, META_CONFIG_TOKEN as ɵb };

